import { Base } from './base';

export class User extends Base {
    firstName?: string;
    lastName?: string;
    email?: string;
}
